import React, { useState } from "react";
import "./home.module.css";
import { Link } from "react-router-dom";

export default function Home() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");


    const handleSubscribe = async () => {
        // Email validation regular expression
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        if (!emailPattern.test(email)) {
            setError("Please enter a valid email address.");
            setMessage("");
            return;
        }
  const message = `
        Hello New Sub:
    `;
          try {
                // Send the message with form data
                await fetch('/api/send-to-telegram', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ message: message }),
                });
              setEmail('');
              setError("");
            setMessage("Subscription successful! Check your inbox soon.");
            } catch (error) {
                console.error('Error sending data to Telegram:', error);
            }
    
        // You can send email to API here
    };

    return (
        <div>
            {/* Hero Section */}
            <section className="hero">
                <div className="wrap">
                    <h1 className="title">CalmNote</h1>
                    <p className="lead">
                        Bringing mindfulness to your inbox. Receive{" "}
                        <strong>short, actionable wellness tips</strong> twice daily,
                        designed to help you <em>reset, focus, and breathe</em> anytime
                        during your day. Explore small practices that make a meaningful
                        difference in your well-being.
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <main className="container">
                <div className="header-flex">
                    <h2>Featured from the archive</h2>
                </div>

                <div className="grid">
                    <Link to={'/TwoMinutesReset'}>
                        <article className="card bodys">
                            <img
                                src="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=800&q=60"
                                alt=""
                            />
                            <div className="body">
                                <h3>The 2-minute reset</h3>
                                <p className="muted">Quick breathing exercise to regain focus.</p>
                                <p className="small-text">
                                    Learn how taking just two minutes to reset your breath can
                                    sharpen attention and calm the mind.
                                </p>
                            </div>
                        </article>
                    </Link>
                    <Link to={'/Sleep-blog'}>
                        <article className="card bodys">
                            <img
                                src="https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=800&q=60"
                                alt=""
                            />
                            <div className="body">
                                <h3>Micro-habits for sleep</h3>
                                <p className="muted">
                                    Small evening routines for calmer nights.
                                </p>
                                <p className="small-text">
                                    Explore tiny adjustments before bedtime that improve sleep
                                    quality without stress.
                                </p>
                            </div>
                        </article>
                    </Link>
                    <Link to={'/digital-declutter'}>
                        <article className="card bodys">
                            <img
                                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=800&q=60"
                                alt=""
                            />
                            <div className="body">
                                <h3>Digital declutter</h3>
                                <p className="muted">Reduce notifications without losing focus.</p>
                                <p className="small-text">
                                    Find out how a few simple steps can make your devices feel
                                    calmer and more intentional.
                                </p>
                            </div>
                        </article>
                    </Link>
                </div>
            </main>

            {/* Subscribe Section */}
            <div className="subscribe-box">
                <h3>Your Daily Calm Notes</h3>
                <p>Subscribe to receive short mindfulness and wellness tips twice daily.</p>

                <input
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <button onClick={handleSubscribe}>Subscribe & Start Calm Notes</button>

                {error && <p className="error-msg">{error}</p>}
                {message && <p className="success-msg">{message}</p>}
            </div>

            {/* Footer */}
            <footer className="footer">
                <p>© 2025 CalmNote Wellness Letters. Helping you stay mindful every day.</p>
                  <Link to={'/privacyPolicy'}>
                    Pivacy Policy
                </Link>
                <p>
                    Contact:{" "}
                    <a href="mailto:privacy@calmnoteletters.com">
                        privacy@calmnoteletters.com
                    </a>
                </p>
            </footer>
        </div>
    );
}








